
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wink/free-study",
      function () {
        return require("private-next-pages/wink/free-study/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wink/free-study"])
      });
    }
  